import React, { FC } from "react";
import { classNames } from "helpers/themeHelpers";
import { useTheme } from "styled-components";
import IconCheckCircled from "assets/IconCheckCircled";
import { AddPostProvider } from "../Providers/AddPostProvider";
import { getIntegrationLink } from "helpers/links-builders/loggedInLinks";
import { EnumIntegrationEvent } from "../../enums/EnumIntegrationEvent";
import Image from "componentReusable/Image";
import { gtmAddPostBtnWidgetSeller } from "GTMs/actions/commonActions";
import { EnumWidgets } from "../../libs/logging/types/loggingTypes";
import { upgradeAccountClick } from "../../libs/logging/helpers/loggingActions";

interface IProps {
  isSameLine?: boolean;
  member_id?: string | number;
  isPostView?: boolean;
}

const WidgetAddListing: FC<IProps> = ({
  isSameLine,
  member_id,
  isPostView = false,
}) => {
  const { isMobile, translations, isDesktop, locale } = useTheme();

  const renderWidgetTitle = () => {
    return (
      <p {...classNames("bold font-20 mb-16 pb-8")}>
        {translations.addListingWidget.title}
      </p>
    );
  };

  const renderAddNewListingButtonForMobile = (onClickCb) => (
    <button
      {...classNames(
        "orangeBtn p-16 flex justifyContent alignItems gap-10 width-100 mt-auto"
      )}
      onClick={(e) => {
        onClickCb(e);
        upgradeAccountClick({
          currentWidgetName: EnumWidgets.ADD_LISTING_CARD,
          member_id,
        });
      }}
    >
      {translations.addListingWidget.addNewListing}
    </button>
  );

  return (
    <section
      id="widgetAddListing"
      {...classNames(
        "border p-16 radius-8 whiteBg",
        isMobile && "mb-16 p-8",
        isDesktop && !isSameLine && "mb-32 mt-8",
        isDesktop && isSameLine && "width-50"
      )}
    >
      {isMobile && renderWidgetTitle()}
      <div
        {...classNames(
          "flex flexSpaceBetween ",
          isDesktop && isSameLine && "gap-20"
        )}
      >
        <div
          {...classNames(
            "flex flexDirectionColumn",
            isDesktop && isSameLine && !isPostView && locale === "ar"
              ? "pb-16"
              : "mb-16 pb-8"
          )}
        >
          {isDesktop && renderWidgetTitle()}
          <div className="flex alignItems mb-16 gap-10 font-14">
            <IconCheckCircled />
            {translations.addListingWidget.item1}
          </div>
            <div className="flex alignItems mb-16 gap-10 font-14">
              <IconCheckCircled />
              {translations.addListingWidget.item2}
            </div>
            <div className="flex alignItems mb-16 gap-10 font-14">
              <IconCheckCircled />
              {translations.addListingWidget.item3}
            </div>
          {isDesktop && !isSameLine && (
            <AddPostProvider
              gtmAction={gtmAddPostBtnWidgetSeller}
              iframeUrl={getIntegrationLink(EnumIntegrationEvent.ADD_POST)}
              render={({ onClickCb }) => (
                <button
                  {...classNames(
                    "orangeBtn p-16 flex justifyContent alignItems gap-10 fullWidth mt-auto"
                  )}
                  onClick={(e) => {
                    onClickCb(e);
                    upgradeAccountClick({
                      currentWidgetName: EnumWidgets.ADD_LISTING_CARD,
                      member_id,
                    });
                  }}
                >
                  {translations.addListingWidget.addNewListing}
                </button>
              )}
            />
          )}
        </div>
        <div
          {...classNames(
            isMobile && "width-33",
            isDesktop && "width-33 ta-e",
            isDesktop && isSameLine && "pt-16"
          )}
        >
          <Image
            src="/images/entryPoints/addNewListing.webp"
            imageType="png"
            width={isDesktop ? "184" : "100"}
            height={isDesktop ? "138" : "74"}
            alt="Add New Listing Image"
            className="width-auto height-auto"
            loading="lazy"
          />
        </div>
      </div>
      {(isMobile || (isDesktop && isSameLine)) && (
        <AddPostProvider
          gtmAction={gtmAddPostBtnWidgetSeller}
          iframeUrl={getIntegrationLink(EnumIntegrationEvent.ADD_POST)}
          render={({ onClickCb }) =>
            renderAddNewListingButtonForMobile(onClickCb)
          }
        />
      )}
    </section>
  );
};

export default WidgetAddListing;
